export default __webpack_public_path__ + "static/media/tt.3ea6b6c1.svg";